import React from 'react';

import { 
  Tooltip,
  Typography,
}                           from '@material-ui/core';

import {
  ResourceRef,
}                           from '../../resource';

export function fmtClientAcl(arrayOfClientIds) {
  if(Array.isArray(arrayOfClientIds)) {
    if(!arrayOfClientIds.includes("NONE") && !arrayOfClientIds.includes("ALL")) {
      return(
        <Tooltip 
          title={<ResourceRef value={arrayOfClientIds} type="Client" format="multiline" linked={false} sorted/>} enterDelay={1000} leaveDelay={200} arrow>
           <Typography align="inherit" variant="inherit">{arrayOfClientIds.length}</Typography>
        </Tooltip>
      );
    } else {
      return(
         <Typography align="inherit" variant="inherit">{arrayOfClientIds.includes("NONE")?"NONE":"ALL"}</Typography>
      );
    }
  }
  return(null);
}

export function fmtClientAclPrincipal(principal, userContext) {
  if(['ALL','NONE'].indexOf(principal) >= 0) {
    return("Shared w/"+principal);
  } else if(userContext) {
    if(userContext.clients && principal in userContext.clients) {
      if(userContext.clients[principal].ClientAccountAlias) {
        return userContext.clients[principal].ClientAccountAlias;
      }
    }
  }
  return principal;
}
